import { render } from "./ProjectenPage.vue?vue&type=template&id=5efee16a"
import script from "./ProjectenPage.vue?vue&type=script&lang=js"
export * from "./ProjectenPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__